import { Component } from '@angular/core';

@Component({
  selector: 'ap-card-footer',
  templateUrl: './card-footer.component.html',
  styleUrls: ['./card-footer.component.css']
})
export class CardFooterComponent {

  constructor() {}

}
